import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ROLE_GVA_ADMIN, ROLE_HK_ADMIN } from '../shared/constants';
import { DeclarationsAuthService } from './declarations-auth.service';

@Component({
  selector: 'ad-authorized',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (isAuthorized) {
      <span><ng-content></ng-content></span>
    }
  `
})
export class AuthorizedComponent implements OnInit {
  public isAuthorized!: boolean;

  constructor(private authService: DeclarationsAuthService) {}

  ngOnInit(): void {
    this.authService
      .hasOneOfRoles$([ROLE_GVA_ADMIN, ROLE_HK_ADMIN])
      .subscribe((hasRole) => (this.isAuthorized = hasRole));
  }
}
